import React from 'react';
import { Form, Button, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import globalMessages from 'translations/messages';

import WebsiteSelect from 'components/WebsiteSelect';
import EditFunnelStep from './EditFunnelStep';
import messages from './messages';

const EditFunnel = () => (
  <>
    <Form.Item name="title" label={<FormattedMessage {...globalMessages.title} />} rules={[{ required: true }]}>
      <Input />
    </Form.Item>
    <Form.Item name="websiteId" label={<FormattedMessage {...globalMessages.website} />} rules={[{ required: true }]}>
      <WebsiteSelect />
    </Form.Item>
    <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues.websiteId !== curValues.websiteId}>
      {({ getFieldValue }) => (getFieldValue('websiteId') && (
        <Form.List name="steps" label={<FormattedMessage {...messages.steps} />}>
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, i) => (
                <Form.Item {...field}>
                  <EditFunnelStep websiteId={getFieldValue('websiteId')} sortIndex={i} onRemove={() => remove(field.name)} />
                </Form.Item>
              ))}
              <Form.Item>
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                  <FormattedMessage {...messages.addStep} />
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      ))}
    </Form.Item>
  </>
);

export default EditFunnel;
